import React from 'react'
import {
  SeeAllCapitals,
  SeeAllCompanies,
  SeeAllOpportunities,
  SeeAllEvents,
  SeeAllSupport,
  SeeAllAdvisors
} from './Types'

export type SeeAllType =
  | 'SeeAllCapitals'
  | 'SeeAllCompanies'
  | 'SeeAllOpportunities'
  | 'SeeAllEvents'
  | 'SeeAllSupport'
  | 'SeeAllAdvisors'

interface Props {
  text: { html: string }
  type: SeeAllType
}

const SeeAll = ({ text, type }: Props) => {
  const types: {
    [key in SeeAllType]: any
  } = {
    SeeAllCapitals,
    SeeAllCompanies,
    SeeAllEvents,
    SeeAllOpportunities,
    SeeAllSupport,
    SeeAllAdvisors
  }

  const SeeAllGrid = types[type]

  if (!SeeAllGrid) return null

  return (
    <div>
      <div
        className='container article pr-lg-6'
        dangerouslySetInnerHTML={{ __html: text.html }}
      />
      <SeeAllGrid />
    </div>
  )
}

export default SeeAll
